import { _deserializable } from '../_deserializable';

export class SigninRequest extends _deserializable {

  public email: string;
  public password: string;

}
